
export default {
  placeInput: {
    findAPlace: 'Ort finden',
    place: 'Ort',
    addRouteStop: 'Wegpunkt hinzufügen',
    routePlace: 'Wegpunkt',
    routeDestination: 'Ziel',
    placeNameRequired: 'Ortsname erforderlich',
    yourLocation: 'Mein Standort',
    couldNotDetermineYourLocation: 'Ihr Standort konnte nicht ermittelt werden. Stellen Sie sicher, dass der Browser die erforderlichen Berechtigungen hat.',
    useYourLocation: 'Meinen Standort nutzen',
    removeInput: 'Ort/Eingabe löschen',
    directions: 'Wegbeschreibung',
    fromYourBrowser: 'Von deinem Browser',
    addStartingPlace: 'Startpunkt hinzufügen',
    startingPlace: 'Startpunkt',
    openInputOptions: 'Eingabeoptionen öffnen',
    addInput: 'Ortseingabe hinzufügen',
    switchCoords: 'Koordinaten tauschen',
    rawCoordinate: 'Lat,Long Koordinaten',
    fillOrRemoveInput: 'Suchen Sie ein Ort oder verwenden Sie die Karten-Schaltfläche auf der rechten Seite',
    noPlaceFound: 'Keine Orte gefunden',
    unknownSearchPlaceError: 'Unbekannter Fehler beim Suchen',
    approximateDistance: 'Ungefähre Entfernung in einer geraden Linie vom aktuellen Kartenmittelpunkt',
    couldNotDetermineYourPreciseLocationUsingPreviousLocation: 'Es war nicht möglich, Ihren genauen Standort zu bestimmen. Stattdessen wird Ihr bisheriger Standort verwendet.',
    pleaseTypeSomething: 'Bitte geben Sie etwas ein, um zu suchen',
    toggleDirect: 'Luftlinie zu nächstem Punkt an/aus',
    clickOnTheMapToSelectAPlace: 'Klicken Sie auf die Karte, um einen Ort auszuwählen',
    clickOnTheMapBtnToPickAPlace: 'Einen Ort auf der Karte auswählen',
    goToDirectionsMode: 'Klicken Sie auf den Wegbeschreibungs-Knopf, um zum Routing-Modus zu wechseln',
    clickToSearchAndShowResultsOnTheMap: 'Hier klicken um zu Suchen und die Ergebnisse auf der Karte anzuzeigen'
  }
}
